import { h, render } from "preact";
import Footer from "./components/Footer/Footer";
import Routes from "./core/Routes";
import { IntlProvider } from "preact-jsx-i18n";
import defaultDefinition from "../src/core/language/en.json";
import { useEffect, useState } from "preact/hooks";

import "./styles/index.css";
import RKMenu from "./components/RKMenu/RKMenu";
import useCurrentRoute from "./hooks/useCurrentRoute";
import useLocale from "./hooks/useLocale";
import { getRoutesByLocale } from "./core/Pages";
import { useRisingClouds } from "./hooks/useRisingClouds";

import gate from "./assets/images/gate.png";
import ParallaxImage from "./components/ParallaxImage/ParallaxImage";

// test out the regular i18n for preact also try out JSON again!

const showFooterHeader = false;

// add a switch to DE
const App = () => {
  const [definition, setDefinition] = useState(defaultDefinition);
  const currentPath = useCurrentRoute();
  const locale = useLocale();
  const routes = getRoutesByLocale(locale);

  // Check if current path matches home route
  const isHomePage = currentPath === routes.HOME;

  // Only show rising clouds on non-home pages
  useRisingClouds(!isHomePage)

  useEffect(() => {
    const sub = PubSub.subscribe("LANGUAGE", mySubscriber);

    return () => PubSub.unsubscribe(sub);
  }, []);

  const mySubscriber = (msg: any, data: "de" | "en") => {
    if (data === "de") {
      import(`../src/core/language/de.json`).then((definition) =>
        setDefinition(definition)
      );
    } else {
      import(`../src/core/language/en.json`).then((definition) =>
        setDefinition(definition)
      );
    }
  };

  return (
    <IntlProvider dictionary={definition}>

      {!isHomePage && <RKMenu />}
      {!isHomePage && <ParallaxImage speed={0.015} />}

      <Routes />

      {showFooterHeader && <Footer />}
    </IntlProvider>
  );
};

render(<App />, document.getElementById("root"));
